import Form from "./components/Form/Form";
import Card from "./components/UI/Card";

function App() {
  return (
    <div className="main">
      <Card>
        <Form />
      </Card>
    </div>
  );
}

export default App;
